import { motion } from "framer-motion";
import { useI18n } from "../../i18n";
import { EASE } from "../../lib/site";

const Chip = ({ children, i }) => (
  <motion.span
    initial={{ opacity: 0, y: 10 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.5, ease: EASE, delay: i * 0.05 }}
    className="rounded-md border border-ink/15 bg-white/70 px-3 py-1.5 font-mono text-sm text-terra"
  >
    {children}
  </motion.span>
);

export const About = () => {
  const { t } = useI18n();
  const a = t.about;
  return (
    <div className="py-4">
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-[190px_1fr]">
        <motion.img
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: EASE }}
          src="/img/portrait-pro.jpg"
          alt="Ruiting Zou"
          data-testid="about-portrait"
          className="aspect-[3/4] w-full rounded-2xl object-cover object-top shadow-[0_18px_36px_-18px_rgba(26,26,26,0.35)]"
        />
        <div>
          <h2 data-testid="about-title" className="font-serif text-3xl leading-tight text-ink">{a.title}</h2>
          <p className="mt-3 font-serif text-lg italic text-terra">{a.italic}</p>
          {a.paragraphs.map((p, i) => (
            <p key={i} data-testid={`about-intro-${i}`} className="mt-4 text-[0.95rem] leading-relaxed text-body-ink">{p}</p>
          ))}
          <p className="mt-5 font-serif text-lg italic text-ink">{a.closing}</p>
        </div>
      </div>
      <div className="mt-9">
        <h3 className="font-serif text-xl text-ink">{a.skillsLabel}</h3>
        <div className="mt-3 flex flex-wrap gap-2.5">
          {a.skills.map((s, i) => <Chip key={s} i={i}>{s}</Chip>)}
        </div>
        <h3 className="mt-8 font-serif text-xl text-ink">{a.languagesLabel}</h3>
        <div className="mt-3 flex flex-wrap gap-2.5">
          {a.languages.map((l, i) => <Chip key={l} i={i}>{l}</Chip>)}
        </div>
      </div>
    </div>
  );
};
